import styled from 'styled-components';
import { Fonts, Palette } from '../../../components/utils';

export const DetailHeaderBlock = styled.div`
  align-self: stretch;
  padding: 24px 20px;
  border-bottom: 1px solid ${Palette.STROKE_GREY};
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
`;

export const DetailHeaderRow = styled.div`
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const DetailHeaderTitle = styled.h2`
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  color: ${Palette.BLACK};
  font-family: ${Fonts.RED_HAT_FONT}, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DetailHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const DetailCloseButton = styled.button`
  width: 24px;
  height: 24px;
  padding: 0;
  border: 1px solid ${Palette.STROKE_GREY};
  border-radius: 50%;
  background: ${Palette.WHITE};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;

  &:focus-visible {
    outline: 2px solid ${Palette.HAZY_BLUE};
    outline-offset: 2px;
  }
`;

export const DetailBannerImg = styled.img`
  align-self: stretch;
  width: 100%;
  height: 177px;
  object-fit: cover;
  display: block;
  flex-shrink: 0;
`;

export const DetailsMainContent = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
  padding-bottom: 24px;
`;

export const DetailsBodySection = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;

  ${DetailsMainContent} > &:first-child {
    padding-top: 24px;
  }
`;

export const DetailsSectionHeader = styled.div`
  align-self: stretch;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const DetailsSectionTitle = styled.div`
  color: ${Palette.BLACK};
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
`;

export const SecondaryPillButton = styled.button`
  box-sizing: border-box;
  min-width: 112px;
  height: 28px;
  padding: 2px 16px;
  border-radius: 999px;
  border: 1px solid ${Palette.HAZY_BLUE};
  background: ${Palette.WHITE};
  color: ${Palette.HAZY_BLUE};
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    filter: brightness(0.95);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const DetailsCardWrap = styled.div`
  align-self: stretch;
  padding: 0 20px;
`;

export const DetailsCard = styled.div`
  padding: 20px;
  background: ${Palette.GHOST_WHITE};
  border-radius: 8px;
  border: 1px solid #a1a3ab;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DetailsCardRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-start;
`;

export const DetailsCardItem = styled.div`
  flex: 1 1 0;
  min-width: 140px;
  display: flex;
  flex-direction: column;
`;

export const DetailsCardLabel = styled.div`
  color: ${Palette.OCEANIC};
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
`;

export const DetailsCardValue = styled.div`
  color: ${Palette.BLACK};
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
`;

export const ApproveBookingButton = styled.button`
  box-sizing: border-box;
  width: 100%;
  align-self: stretch;
  height: 40px;
  padding: 8px 32px;
  border: none;
  border-radius: 999px;
  background: ${Palette.HAZY_BLUE};
  color: ${Palette.WHITE};
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;

  &:hover:not(:disabled) {
    filter: brightness(1.05);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CancelBookingButton = styled.button`
  box-sizing: border-box;
  width: 100%;
  align-self: stretch;
  height: 40px;
  padding: 8px 32px;
  border-radius: 999px;
  border: 1px solid ${Palette.HAZY_BLUE};
  background: ${Palette.WHITE};
  color: ${Palette.HAZY_BLUE};
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;

  &:hover:not(:disabled) {
    filter: brightness(0.95);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const StatusBadgeWrap = styled.div`
  display: inline-flex;
`;
